import { cn } from '@invent/wl-ui-kit-next';
import { Button } from '@invent/wl-ui-kit-next/ui';
import { RefreshCw } from 'lucide-react';

import { CondensedTip, useCondensed } from './condense';

/** Refresh by hand, where nothing polls: ↻ and the word, held off while the read is out, then
 *  "updated 10:44". Lists' toolbar and a ranking's record draw the same one (19 Oct). In a work
 *  page's compact bar, ↻ alone, the word and the time in its tooltip. */
export function RefreshButton({
  reading,
  readAt,
  onClick
}: {
  reading: boolean;
  readAt: Nullable<Date>;
  onClick: () => void;
}) {
  const { condensed } = useCondensed();
  const updated = reading && readAt === null ? 'Reading…' : readAt ? `updated ${clock(readAt)}` : '';
  return (
    <>
      <CondensedTip label={updated ? `Refresh — ${updated}` : 'Refresh'}>
        <Button
          type="button"
          variant="ghost"
          className={cn('h-8 gap-1.5 font-normal', condensed ? 'w-8 px-0' : 'px-2.5')}
          aria-label={condensed ? 'Refresh' : undefined}
          disabled={reading}
          onClick={onClick}
        >
          <RefreshCw className="size-4" aria-hidden />
          {!condensed && 'Refresh'}
        </Button>
      </CondensedTip>
      <span data-updated="" className={cn('text-xs tabular-nums text-muted-foreground', condensed && 'hidden')}>
        {updated}
      </span>
    </>
  );
}

/** "10:44" in the viewer's own zone. */
function clock(at: Date): string {
  return at.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
}
